import React from 'react';

const LoginTextButton = ({children, onClick, inline, className}) => {
	return (
		<p onClick={onClick} style={{ width: inline ? "auto" : "100%", lineHeight: '1rem' }} className={`text-align-center text-link-block${className ? ' ' + className : ''}`}>{children}</p>
   );
}

export default LoginTextButton;